<template>
    <page>
        <module title="商城配置">
        <c-form ref="form">
				<c-form title="平台功能控制">
					<c-form-item type="radio"  label="会员向平台下单" :options="switchOptions"  name="IS_CAN_ORDER" word="注:关闭后,则会员不允许向平台下单,经销商向上级经销商进货不受此影响"></c-form-item>
					<c-form-item type="radio"  label="会员向平台申请售后" :options="switchOptions"  name="IS_CAN_AFTERSALE" word="注:关闭后,则平台不允许订单申请售后"></c-form-item>
					<c-form-item type="radio"  label="会员修改订单收货地址" :options="switchOptions"  name="IS_CAN_EDIT_ORDER_ADDRESS" word="注:开启后,则平台允许待发货的订单修改收货地址"></c-form-item>
				</c-form>
				<c-form title="平台基本配置">
					<c-form-item type="number" decimal="2" label="超期未支付自动关闭" name="ORDER_AUTO_CLOSE_TIME"  :limit="[0.1,999]" input-unit="时"></c-form-item>
					<c-form-item type="radio"  label="库存扣减方式" :options="occupancyTypeOptions"  name="INVENTORY_OCCUPANCY_TYPE" word=""></c-form-item>
					<c-form-item type="radio" label="缺货订购" :options="outstockOptions"  name="IS_OUTSTOCK" word="注:开启缺货订购则客户可以下单购买无库存的商品"></c-form-item>
					<c-form-item type="number" label="发货后自动确认" name="ORDER_CONFIRM_DATE" :limit="[0,100]" input-unit="天" word="客户未确认收货,系统自动确认收货"></c-form-item>
					<c-form-item type="number" label="退货政策期" name="ORDER_RETURN_POLICY_PERIOD" :limit="[0,999]" input-unit="天" word="确认收货后，X天内允许发起退货申请,X天后清分结算"></c-form-item>
					<c-form-item type="number" decimal="2" label="订单包邮金额" name="FREE_POSTAGE_ORDER_PRODUCT_MONEY" :limit="[0.01,99999999]" input-unit="元" word="单个订单商品金额≥该数值，则不收取邮费"></c-form-item>
					<c-form-item type="number" decimal="0" label="订单包邮数量" name="FREE_POSTAGE_ORDER_PRODUCT_COUNT" :limit="[1,99999999]" input-unit="件" word="单个订单商品数量≥该数值，则不收取邮费"></c-form-item>
					<c-form-item type="input" label="官方店铺名称" name="PLATFORM_SHOP_NAME" maxlength="20" word="购物车、订单等位置展示，最多输入20个字符"></c-form-item>
					<c-form-item type="number" decimal="1" label="邀新有效期" name="INVITE_VALID_PERIOD"  :limit="[0.1,999999]" word="新用户邀请有效时间，被邀请人必须在该时间内下单，才能成为邀请人的下级会员，超期则邀请关系无效" input-unit="时"></c-form-item>
				</c-form>
				<c-form title="会员财务相关配置">
					<c-form-item type="number" decimal="2" :limit="[0,99]" label="账户提现手续费率" name="WITHDRAWAL_RATE" input-unit="%" word="费率非0时，最低收取0.1元（支持提现时有效）"></c-form-item>
					<c-form-item type="number" decimal="2" :limit="[0.01,9999999]" label="账户单次提现下限" name="A_SINGLE_WITHDRAWAL_MIN"  word="单次提现不小于该数值（支持提现时有效）"></c-form-item>
					<c-form-item type="number" decimal="2" :limit="[0.01,9999999]" label="账户单次提现上限" name="A_SINGLE_WITHDRAWAL_LIMIT" input-unit="元" word="单次提现不超过该数值（支持提现时有效）"></c-form-item>
					<c-form-item type="radio" v-if="systemConfig.credit_pay == 'ON'" label="出账方式" :options="payPeriodType"  name="PAY_PERIOD_TYPE" ></c-form-item>
					<c-form-item type="number" v-if="systemConfig.credit_pay == 'ON'" label="出账后还款天数" name="PAY_PERIOD_VALUE"  input-unit="天"></c-form-item>
				</c-form>
		        <c-form title="银行转账信息配置" v-if="false">
			        <c-form-item type="input" label="收款银行" name="TRANSFER_BANK_NAME" maxlength="30" word="转账收款银行名称，最多输入30个字符"></c-form-item>
			        <c-form-item type="input" label="收款户名" name="TRANSFER_BANK_ACCOUNT_NAME" maxlength="30" word="转账收款银行账户名，最多输入30个字符"></c-form-item>
			        <c-form-item type="input" label="收款账号" name="TRANSFER_BANK_ACCOUNT_NUMBER" maxlength="30" word="转账收款银行账号，最多输入30个字符"></c-form-item>
		        </c-form>
				<c-form title="商家财务相关配置" v-if="systemConfig.pt_mode == '2' || systemConfig.oms_seller_shop_enabled =='ON'">
					<c-form-item type="number" decimal="2" :limit="[0,99]" label="账户提现手续费率" name="STATION_WITHDRAWAL_RATE"  input-unit="%" word="费率非0时，最低收取0.1元"></c-form-item>
					<c-form-item type="number" decimal="2" :limit="[0.01,9999999]" label="账户单次提现上限" name="STATION_A_SINGLE_WITHDRAWAL_LIMIT" input-unit="元" word="单次提现不超过该数值"></c-form-item>
				</c-form>
				<c-form title="移动端基础配置">
					<c-form-item type="image" label="移动端登陆页Logo" name="SYS_APP_LOGIN_LOGO_IMG" word="移动端登录页显示的Logo,【建议尺寸：180X180px,支持jpg、png，图片大小1M以内】"></c-form-item>
					<c-form-item type="image" label="用户默认头像" name="DEFAULT_HEAD_PHOTO" word="用户默认头像Logo,【建议尺寸：140 x 140,支持jpg、png，图片大小100KB以内】"></c-form-item>
				</c-form>
				<c-form title="PC基础配置" v-if="systemConfig.pc_enabled == 'ON'">
					<c-form-item type="input" label="PC平台名称" name="PLATFORM_NAME"></c-form-item>
					<c-form-item type="image" label="PC网站ICON图标" name="PLATFORM_PC_FAVICON" file-word="PC网站ICON图标,【建议尺寸：32X32px,支持jpg、png，图片大小1M以内】"></c-form-item>
					<c-form-item type="image" label="PC商城（主）Logo" name="PLATFORM_PC_LOGO_BIG" file-word="PC首页、商品列表等页面显示,【建议尺寸：高度100px,宽度560px以内,支持jpg、png，图片大小1M以内】"></c-form-item>
					<c-form-item type="image" label="PC商城（小）Logo" name="PLATFORM_PC_LOGO_SMALL" file-word="PC购物车、下单等页面显示,【建议尺寸：130X80px,支持jpg、png，图片大小1M以内】"></c-form-item>
					<c-form-item type="textarea" label="网站描述" name="PC_DESCRIPTION"   ></c-form-item>
					<c-form-item type="textarea" label="网站关键词" name="PC_KEYWORDS"   ></c-form-item>
					<c-form-item type="input" label="ICP备案信息" name="ICP"   ></c-form-item>
					<c-form-item type="input" label="版权信息" name="COPYRIGHT"   ></c-form-item>
				</c-form>
				<c-form title="PC其他配置" v-if="systemConfig.pc_enabled == 'ON'">
					<c-form-item type="image" label="二维码1图" name="ITEM1_IMG" file-word="首页底部/侧边栏等处使用,【建议尺寸：480X480px,支持jpg、png，图片大小1M以内】"></c-form-item>
					<c-form-item type="input" label="二维码1名称" name="ITEM1_TITLE" word="首页底部/侧边栏等处使用" ></c-form-item>
					<c-form-item type="image" label="二维码2图" name="ITEM2_IMG" file-word="首页底部/侧边栏等处使用,【建议尺寸：480X480px,支持jpg、png，图片大小1M以内】"></c-form-item>
					<c-form-item type="input" label="二维码2名称" name="ITEM2_TITLE" word="首页底部/侧边栏等处使用" ></c-form-item>
					<c-form-item type="input" label="客服电话" name="CUSTOMER_SERVICE_PHONE"   ></c-form-item>
					<c-form-item type="input" label="联系邮箱" name="CUSTOMER_SERVICE_EMAIL"   ></c-form-item>
					<c-form-item type="editor" label="登录页底部导航" name="PC_BOTTOM_NAV"  ></c-form-item>
					<c-form-item type="editor" label="页面底部通用导航" name="COMMON_NAV"   ></c-form-item>
					<c-form-item type="editor" label="订购说明" name="ORDER_REMARK"   ></c-form-item>
				</c-form>
				<c-form title="运营后台基础配置">
					<c-form-item type="input" label="系统名称" name="OMS_SYSTEM_NAME"></c-form-item>
					<c-form-item type="image" label="登录页Logo" name="OMS_LOGIN_LOGO" file-word="【建议尺寸：140X140px,支持jpg、png，图片大小1M以内】"></c-form-item>
					<c-form-item type="image" label="内页Logo" name="OMS_LOGO" file-word="【建议尺寸：200X150px,支持jpg、png，图片大小1M以内，最好是透明图】"></c-form-item>
					<c-form-item type="image" label="ICON图标" name="OMS_FAVICON" file-word="【建议尺寸：32X32px,支持jpg、png，图片大小1M以内】"></c-form-item>
					<c-form-item type="input" label="版权信息" name="OMS_COPYRIGHT" ></c-form-item>
				</c-form>
				<c-form title="商家基础配置" v-if="systemConfig.pt_mode == '2'">
					<c-form-item type="input" label="系统名称" name="SCS_SYSTEM_NAME"></c-form-item>
					<c-form-item type="image" label="登录页Logo" name="SCS_LOGIN_LOGO" file-word="【建议尺寸：高度140px,宽度600px以内,支持jpg、png，图片大小1M以内】"></c-form-item>
					<c-form-item type="image" label="内页Logo" name="SCS_LOGO" file-word="【建议尺寸：400X88px,支持jpg、png，图片大小1M以内，最好是透明图】"></c-form-item>
					<c-form-item type="image" label="ICON图标" name="SCS_FAVICON" file-word="【建议尺寸：32X32px,支持jpg、png，图片大小1M以内】"></c-form-item>
					<c-form-item type="input" label="版权信息" name="SCS_COPYRIGHT" ></c-form-item>
					<c-form-item type="input" label="招商电话" name="SCS_INVESTMENT_HOTLINE" ></c-form-item>
					<c-form-item type="input" label="客服电话" name="SCS_CUSTOMER_SERVICE_TELEPHONE" ></c-form-item>
				</c-form>
                <c-form title="平台政策说明" v-if="systemConfig.pc_enabled == 'ON'">
					<c-form-item type="textarea" label="配送信息" name="DELIVERY_REMARK"   ></c-form-item>
					<c-form-item type="textarea" label="支付方式" name="PAYMENT_REMARK"   ></c-form-item>
					<c-form-item type="textarea" label="退换货政策" name="RETURN_REMARK"   ></c-form-item>
				</c-form>
      </c-form>

            <template slot="button">
                <c-button size="m" power="b_mall_config_edit" @click="save()">保存</c-button>
            </template>
        </module>

    </page>
</template>

<script>
	import {mapState} from 'vuex'
	
    export default {
        name: 'm_mall_config',

        components: {
        },

        props: {
            id: String
        },

        data() {
            return {
                fromData:{
                },
                switchOptions: [{
                    name: '开启',
                    value: 'ON'
                }, {
                    name: '关闭',
                    value: 'OFF'
                }],
                payPeriodType:[{
                    name: '发货后',
                    value: '1'
                }, {
                    name: '开票后',
                    value: '2'
                }],
	            occupancyTypeOptions:[{
                    name: '下单后扣减',
                    value: '1'
                }, {
                    name: '支付后扣减',
                    value: '2'
                }],
	            outstockOptions: [{
		            name: '不支持',
		            value: '0'
	            }, {
		            name: '支持',
		            value: '1'
	            }],
            }
        },
		computed: {
			...mapState(['systemConfig'])
		},

        watch: {

        },

        mounted() {
            this.getDetail();
        },

        methods: {
            getDetail() {
                this.request({
                    url: '/platform_config/list',
                    data: {
                        config_group: ""
                    },
                    loading: true,
                    success: data => {
                        let json = {};
                        data.forEach(function (item,i){
							if(item.config_item_code=='STATION_WITHDRAWAL_RATE' || item.config_item_code=='WITHDRAWAL_RATE'){
								json[item.config_item_code] = parseFloat(item.config_item_value) * 100;
							}else{
								json[item.config_item_code] = item.config_item_value;
							}
                        });
                        this.$refs.form.set(json);

                    }
                });
            },


            save() {
                this.$refs.form.submit({
                    url: '/platform_config/edit',
                    dataFormatter: data => {
                        let arr = [];
                        for (let key in data) {
							if(key=='STATION_WITHDRAWAL_RATE' || key=='WITHDRAWAL_RATE'){
								arr.push({
								    config_item_code: key,
								    config_item_value: data[key] ? parseFloat(data[key].toString()) / 100 : 0
								});
							}else{
								arr.push({
								    config_item_code: key,
								    config_item_value: data[key] ? data[key].toString() : ''
								});
							}
                        }
                        return {
                            platform_config_list: arr
                        };
                    },
                    success: () => {
						this.$store.dispatch('getSystemConfig');
                        this.$message({
                            text: '操作成功'
                        });

                    }
                });
            }
        }
    }
</script>

<style lang="stylus" scoped>


</style>